var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4421 5.53125V6.75H1.06706V5.53125C1.06706 4.87109 1.57488 4.3125 2.28581 4.3125H24.2233C24.8835 4.3125 25.4421 4.87109 25.4421 5.53125ZM24.6296 1.46875V2.6875H1.87956V1.46875C1.87956 0.808594 2.38738 0.25 3.09831 0.25H23.4108C24.071 0.25 24.6296 0.808594 24.6296 1.46875ZM13.2546 16.8047C14.0671 16.8047 14.778 17.3125 14.7272 17.9219C14.7272 18.5312 14.0671 19.0391 13.2546 19.0391C12.3913 19.0391 11.7311 18.5312 11.7311 17.9219C11.7311 17.3125 12.3913 16.8047 13.2546 16.8047ZM24.6296 8.375C25.4928 8.375 26.2546 9.13672 26.2546 10C26.2546 10.0508 26.2038 10.1523 26.2038 10.1523L24.8835 24.7773C24.8327 25.5898 24.071 26.25 23.2585 26.25H3.19988C2.38738 26.25 1.62566 25.5898 1.57488 24.7773L0.254564 10.1523C0.254564 10.1523 0.203783 10.0508 0.203783 10C0.203783 9.13672 0.965502 8.375 1.82878 8.375H1.87956H24.6296ZM13.2546 24.2695C18.028 24.2695 22.0905 21.5273 22.3444 17.9219C22.5983 14.1641 18.5358 10.9141 13.2546 10.9141C7.92253 10.9141 3.86003 14.1641 4.11394 17.9219C4.36785 21.5273 8.43035 24.2695 13.2546 24.2695Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.a7ac63146b545b9c977d44637476f178.svg";
export { ForwardRef as ReactComponent };